var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
        },
        [
          _c(
            "draggable",
            {
              on: { end: _vm.onEnd },
              model: {
                value: _vm.itemInfo.marketLists,
                callback: function ($$v) {
                  _vm.$set(_vm.itemInfo, "marketLists", $$v)
                },
                expression: "itemInfo.marketLists",
              },
            },
            _vm._l(_vm.itemInfo.marketLists, function (item, index) {
              return _c("el-card", { key: index, staticClass: "market-item" }, [
                !_vm.isAlone
                  ? _c(
                      "div",
                      { staticClass: "flex market-field" },
                      [
                        _c("div", { staticClass: "market-field-label" }, [
                          _vm._v("标题："),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "market-field-input",
                          attrs: { placeholder: "请输入" },
                          on: { blur: _vm.updateItem },
                          model: {
                            value: item.headtitle,
                            callback: function ($$v) {
                              _vm.$set(item, "headtitle", $$v)
                            },
                            expression: "item.headtitle",
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-remove market-field-remove",
                          on: {
                            click: function ($event) {
                              return _vm.removeNavItem(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAlone
                  ? _c(
                      "div",
                      { staticClass: "flex market-field" },
                      [
                        _c("div", { staticClass: "market-field-label" }, [
                          _vm._v("副标题标题："),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "market-field-input",
                          attrs: { placeholder: "请输入" },
                          on: { blur: _vm.updateItem },
                          model: {
                            value: item.subHeadtitle,
                            callback: function ($$v) {
                              _vm.$set(item, "subHeadtitle", $$v)
                            },
                            expression: "item.subHeadtitle",
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-remove market-field-remove",
                          on: {
                            click: function ($event) {
                              return _vm.removeNavItem(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex market-field",
                    staticStyle: { "align-items": "baseline" },
                  },
                  [
                    _c("div", { staticClass: "market-field-label" }, [
                      _vm._v("内容："),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "market-field-input" }, [
                      _c(
                        "div",
                        {
                          staticStyle: { color: "#0467e5", cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              return _vm.settingMarketItem(index, item)
                            },
                          },
                        },
                        [_vm._v("内容设置")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "market-field-remark" }, [
                        _vm._v(
                          "当前设置：" + _vm._s(_vm.marketItemRemark(item))
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n\t\t\t\t\t\t随机排序："),
                    _c("el-switch", {
                      attrs: {
                        "active-value": 1,
                        "active-text": "显示",
                        "inactive-text": "隐藏",
                        "inactive-value": 0,
                      },
                      on: { change: _vm.updateItem },
                      model: {
                        value: item.roderSort,
                        callback: function ($$v) {
                          _vm.$set(item, "roderSort", $$v)
                        },
                        expression: "item.roderSort",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          !_vm.isAlone ||
          !_vm.itemInfo.marketLists ||
          !_vm.itemInfo.marketLists.length
            ? _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.addMarketContent },
                },
                [_vm._v("添加模块")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          staticClass: "market-style-form",
          attrs: { model: _vm.itemInfo, "label-width": "160px" },
        },
        [
          !_vm.isAlone
            ? _c(
                "el-form-item",
                { attrs: { label: "标题展示方式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.titleStyleOne,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "titleStyleOne", $$v)
                        },
                        expression: "itemInfo.titleStyleOne",
                      },
                    },
                    _vm._l(_vm.titleListStyle, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.key, attrs: { label: item.key } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "展示方式：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsShowType,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "goodsShowType", $$v)
                    },
                    expression: "itemInfo.goodsShowType",
                  },
                },
                [
                  _vm._l(_vm.SHOW_ALIGN_OPTIONS, function (item) {
                    return _c(
                      "el-radio",
                      { key: item.key, attrs: { label: item.key } },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isAlone
                    ? _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("横向3排列"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAlone
                    ? _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v("横向4排列"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示商品名称：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "显示",
                  "inactive-text": "隐藏",
                  "inactive-value": 0,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.showTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "showTitle", $$v)
                  },
                  expression: "itemInfo.showTitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isAlone
            ? _c(
                "el-form-item",
                { attrs: { label: "是否显示类目弹框：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.showCatePopup,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "showCatePopup", $$v)
                        },
                        expression: "itemInfo.showCatePopup",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不显示"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAlone && Number(_vm.itemInfo.showCatePopup) === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "类目背景颜色：", required: "" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.cateBgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "cateBgColor", $$v)
                      },
                      expression: "itemInfo.cateBgColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAlone && Number(_vm.itemInfo.showCatePopup) === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "类目标题字体颜色：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.cateTitleColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "cateTitleColor", $$v)
                      },
                      expression: "itemInfo.cateTitleColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示价格：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": true,
                  "active-text": "显示",
                  "inactive-text": "隐藏",
                  "inactive-value": false,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.showPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "showPrice", $$v)
                  },
                  expression: "itemInfo.showPrice",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAlone
            ? _c(
                "el-form-item",
                { attrs: { label: "展示样式：" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "price-style-options",
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.newPricePosition,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "newPricePosition", $$v)
                        },
                        expression: "itemInfo.newPricePosition",
                      },
                    },
                    _vm._l(_vm.priceStyle, function (item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.key,
                          staticClass: "price-style-option",
                          attrs: { label: item.key, disabled: item.key === 1 },
                        },
                        [
                          _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.name)),
                          item.key === 1
                            ? _c("span", { staticClass: "required-badge" }, [
                                _vm._v("必选"),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.itemInfo.goodsShowType == 1 ||
          _vm.itemInfo.goodsShowType == 2 ||
          !_vm.isAlone
            ? _c(
                "el-form-item",
                { attrs: { label: "是否分页：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "active-text": "是",
                      "inactive-text": "否",
                      "inactive-value": 0,
                    },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.showPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "showPage", $$v)
                      },
                      expression: "itemInfo.showPage",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.itemInfo.goodsShowType == 1 ||
            _vm.itemInfo.goodsShowType == 2 ||
            !_vm.isAlone) &&
          _vm.itemInfo.showPage === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "商品每页数量：" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.pageLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "pageLimit", $$v)
                      },
                      expression: "itemInfo.pageLimit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.itemInfo.goodsShowType == 1 ||
            _vm.itemInfo.goodsShowType == 2 ||
            !_vm.isAlone) &&
          _vm.itemInfo.showPage === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "分页样式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.pagesStyleTyepe,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "pagesStyleTyepe", $$v)
                        },
                        expression: "itemInfo.pagesStyleTyepe",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("样式一"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("样式二"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isAlone &&
          (_vm.itemInfo.goodsShowType === 3 || _vm.itemInfo.goodsShowType === 4)
            ? _c(
                "el-form-item",
                { attrs: { label: "是否轮播：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "active-text": "是",
                      "inactive-text": "否",
                      "inactive-value": 0,
                    },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.newIsSwiper,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "newIsSwiper", $$v)
                      },
                      expression: "itemInfo.newIsSwiper",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isAlone &&
          (_vm.itemInfo.goodsShowType === 3 ||
            _vm.itemInfo.goodsShowType === 4) &&
          _vm.itemInfo.newIsSwiper
            ? _c(
                "el-form-item",
                { attrs: { label: "播放间隔：" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.newVideoLoop,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "newVideoLoop", $$v)
                      },
                      expression: "itemInfo.newVideoLoop",
                    },
                  }),
                  _vm._v("秒\n\t\t\t"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主题风格：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.titleColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "titleColor", $$v)
                  },
                  expression: "itemInfo.titleColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "bgImg")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.bgImg },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "边框色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.newBorderColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "newBorderColor", $$v)
                  },
                  expression: "itemInfo.newBorderColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.borderRadius
            ? _c("el-form-item", { attrs: { label: "外框圆角：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("上："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.borderRadius.pt,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.borderRadius, "pt", $$v)
                        },
                        expression: "itemInfo.borderRadius.pt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("下："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.borderRadius.pb,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.borderRadius, "pb", $$v)
                        },
                        expression: "itemInfo.borderRadius.pb",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("左："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.borderRadius.pl,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.borderRadius, "pl", $$v)
                        },
                        expression: "itemInfo.borderRadius.pl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("右："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.borderRadius.pr,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.borderRadius, "pr", $$v)
                        },
                        expression: "itemInfo.borderRadius.pr",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.goodsPadding, "pt", $$v)
                    },
                    expression: "itemInfo.goodsPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.goodsPadding, "pb", $$v)
                    },
                    expression: "itemInfo.goodsPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.goodsPadding, "pl", $$v)
                    },
                    expression: "itemInfo.goodsPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.goodsPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.goodsPadding, "pr", $$v)
                    },
                    expression: "itemInfo.goodsPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "内部间距：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.midPadding,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "midPadding", $$v)
                  },
                  expression: "itemInfo.midPadding",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mt", $$v)
                    },
                    expression: "itemInfo.formMargin.mt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mb", $$v)
                    },
                    expression: "itemInfo.formMargin.mb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.ml,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "ml", $$v)
                    },
                    expression: "itemInfo.formMargin.ml",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mr", $$v)
                    },
                    expression: "itemInfo.formMargin.mr",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditMarket", {
        ref: "EditMarketRef",
        attrs: { pageType: _vm.pageType },
        on: { saveEdit: _vm.saveEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }